import { useRef } from "react";
import useEvent from "../../hooks/useEvent";
import useModalEvent from "../../hooks/useModalEvent";
import { ImportLogOverlay } from "../../components/ImportLogOverlays/ImportLogOverlay";

export const ImportTasksLogOverlay = () => {
  const overlayRef = useRef(null);
  const { Events, useRegisterCustomEvent } = useEvent();
  const { ModalEvents, toggleModal } = useModalEvent();

  useRegisterCustomEvent(Events.ImportLogOverlay, () => {
    if (overlayRef.current) {
      overlayRef.current.show();
    }
  });

  return (
    <ImportLogOverlay
      id={"dd_task-import-log-overlay"}
      ref={overlayRef}
      type="tasks"
      onReview={({ Errors }) => {
        overlayRef.current?.hide();
        toggleModal(ModalEvents.ImportTasks, {
          step: 2,
          errors: Errors
        });
      }}
      onNewImport={() => {
        overlayRef.current?.hide();
        toggleModal(ModalEvents.ImportTasks);
      }}
    />
  );
};
